import React from 'react';
import Section from './Section';

const skills = {
    "Languages": ["Java", "Python", "C/C++", "R", "Swift", "JavaScript"],
    "Frontend": ["React.js", "SwiftUI", "HTML/CSS", "Tailwind CSS"],
    "Backend": ["Flask", "Node.js", "RESTful APIs", "PostgreSQL"],
    "Tools & Cloud": ["AWS", "Firebase", "Git", "Docker", "Selenium"]
};

export default function Skills() {
    return (
        <Section id="skills" className="bg-warm-white">
            <h2 className="text-3xl font-serif font-bold text-center text-charcoal mb-16">Technical Skills</h2>

            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
                {Object.entries(skills).map(([category, items]) => (
                    <div key={category} className="text-center md:text-left">
                        <h3 className="font-serif text-lg font-bold text-earth-brown mb-4 border-b border-warm-grey pb-2 inline-block md:block">
                            {category}
                        </h3>
                        <ul className="space-y-2">
                            {items.map(item => (
                                <li key={item} className="text-charcoal/80 text-sm">
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </Section>
    );
}
